var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('MultiSearch', {
    ref: "multiSearch",
    attrs: {
      "data-cy": "multi-search",
      "search-config": _vm.searchConfig,
      "show-condition": "",
      "show-operator": "",
      "readonly": _vm.readonly
    },
    on: {
      "search-updated": _vm.onSearchUpdate
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };